import React from 'react';
import Oidc from 'oidc-client';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withUserData } from 'common/sessionStore/withUserData.js';

//Identityserver needs this page to call back to in order to complete its sign in process
class LoginCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loggedIn: false };
    new Oidc.UserManager({ clockSkew: 86400 })
      .signinRedirectCallback()
      .then(() => {
        this.props.history.push(this.props.userData.currentPath || '/');
      })
      .catch((e) => {
        console.error(e);
        this.props.history.push('/ErrorPage');
      });
  }

  render() {
    return null;
  }
}

LoginCallback.propTypes = {
  userData: PropTypes.object, //from withUserData HOC
};

export default compose(withRouter, withUserData)(LoginCallback);
